import Vue from "vue";
import Router from "vue-router"
import Home from './Home'
import Menus from './components/Menus'
import Order from './components/Order'
import OrderMonitor from './components/OrderMonitor'

Vue.use(Router);

export default new Router({
  mode: "history",
  routes:[
    {
      path: '/',           //パスの設定
      component: Home,    //表示するコンポーネント
    },
    {
      path: '/menus',            
      component: Menus,
    },
    {
        path : '/order',
        component : Order,
    },
    {
      path : '/orderMonitor',
      component : OrderMonitor,
  }

  ]
});